import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ml-3 mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "textDashboard mt-4 ml-3" }
const _hoisted_5 = { class: "textDashboard mt-2 ml-3 mb-3" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "textDashboard mt-4 ml-3" }
const _hoisted_8 = { class: "textDashboard mt-4 ml-3" }
const _hoisted_9 = { class: "textDashboard ml-3 mb-3" }

import { ref, Ref } from 'vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALARMTYPE } from '@/interfaces/SmartLink/KPI';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { COLOR } from '@/constants/colors';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'TimeLineAlerts',
  props: {
    arrayItems  : { type:Array<ALARMTYPE>, required: true },
    width       : { type: Number, default: 300 },
    height      : { type: Number, default: 200 },
    isRecurrent : { type: Boolean, default: false}
},
  setup(__props) {

const { t } = useI18n()

const props = __props

const items:Ref<ALARMTYPE[]> = ref(props.arrayItems);

/**
 * Genera el mensaje que se mostrará en el componente de alarmas recurrentes
 * @param causa 
 * @param ip 
 * @param detalle 
 * @param recurrencia 
 * @param status 
 * @param name 
 * @param tipo 
 * @param subtipo 
 */
const getMessage = (causa:string, ip:string, detalle:string, recurrencia: number, status:string, name:string, tipo:string, subtipo:string) => {
    let finalDetalle = JSON.parse(detalle)
    let messageFinal = `
    Se ha detectado una ${status} recurrente en el equipo ${ip} - ${name} [ ${subtipo} - ${tipo} ]  ${causa}: "Latencia: ${finalDetalle.latencia}". Ha ocurrido ${recurrencia} veces.`;

    return messageFinal
}

/**
 * Genera el mensaje que se mostrará el componentes de Alertas/Alarmas, bajo el IEO
 * @param detalle 
 */
const getDetalle = (detalle:string) => {
    let finalDetalle = JSON.parse(detalle)
    let messageFinal = `Latencia: ${finalDetalle.latencia}`;

    return messageFinal
}


/**************************************
****** ACTIVAR/DESACTIVAR SCROLL ******
**************************************/

// Se colocó un elemento delante del gráfico para que cuando se pase el mouse por encima, se evite
// hacer el scroll dentro del gráfico, con el fin de evitar inconvenientes para el usuario final

// variable de la activación/desactivación
const isactive = ref(false);

/**
 * Desactiva el scroll dentro de gráfico
 */
const onClickOutside = () => {
    isactive.value = false;
    classHiddenScroll.value = 'hiddenScroll timelineAlertCard'
}

/**
 * Activa el scroll dentro del gráfico
 */
const isactiveClick = () =>{
    isactive.value = true;
    classHiddenScroll.value = 'showScroll timelineAlertCardSelected';
}

/**
 * Se coloca el scroll en la parte derecha cuando seleccionemos el componente
 */
const classHiddenScroll = ref('hiddenScroll timelineAlertCard')

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_virtual_scroll, {
    items: items.value,
    "max-height": __props.height,
    class: _normalizeClass('timelineStyles '+ classHiddenScroll.value),
    onClick: isactiveClick
  }, {
    default: _withCtx(({ item }) => [
      _createVNode(_component_v_sheet, {
        width: __props.width,
        color: "bgtl",
        class: "ma-2 timelineStyles"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _createVNode(_component_v_chip, {
              vlass: "pl-3",
              color: item.status.toUpperCase() === 'ALERTA' ? _unref(COLOR).red :  _unref(COLOR).yellow,
              variant: "flat"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.status.toUpperCase() === 'ALERTA' ? _unref(t)('labels.alert') : _unref(t)('labels.alarm')), 1)
              ]),
              _: 2
            }, 1032, ["color"]),
            (__props.isRecurrent)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.fecha), 1))
              : _createCommentVNode("", true)
          ]),
          (__props.isRecurrent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.message')) + ": ", 1)
                ]),
                _createElementVNode("p", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(getMessage(item.causa, item.ip, item.detalle, item.recurrencia??0, item.status, item.name, item.tipo, item.subtipo)), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(item.name) + " - " + _toDisplayString(item.ip) + " - " + _toDisplayString(item.fecha), 1)
                ]),
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.cause')) + ": " + _toDisplayString(item.causa), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.detail')) + ": " + _toDisplayString(getDetalle(item.detalle)), 1)
                ])
              ]))
        ]),
        _: 2
      }, 1032, ["width"])
    ]),
    _: 1
  }, 8, ["items", "max-height", "class"])), [
    [_directive_click_outside, {
      handler: onClickOutside
    }]
  ])
}
}

})